module.exports = __webpack_public_path__ + "media/promo/promo/images/chief-2-62ccdbb829c3e4cda07a637720c11b4f.png";